<template>
  <div class="animate__animated animate__fadein animate__delay-0.5s animate__slower">
    <navTeacher></navTeacher>
    <div class="father">
      <el-menu :default-active="defaultpath" class="el-menu-vertical-demo" :router="true"
        active-text-color="rgb(1, 162, 153)">
        <el-submenu index="1">
          <template slot="title">
            <div id="block"></div>
            <span id="title">账户中心</span>
          </template>
          <el-menu-item-group ref="nav">
            <el-menu-item id="smalltitle" index="/personteacher/jianli">我的简历</el-menu-item>
            <el-menu-item id="smalltitle" index="/personteacher/wechat">绑定微信</el-menu-item>
            <el-menu-item id="smalltitle" index="/personteacher/phone">修改手机号</el-menu-item>
            <el-menu-item id="smalltitle" index="/personteacher/pwd">修改密码</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="2">
          <template slot="title">
            <div id="block"></div>
            <span id="title">订单中心</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/personteacher/chuli" id="smalltitle">预约处理</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item index="/personteacher/message">
          <div id="block"></div>
          <span slot="title" id="title">我的消息</span>
        </el-menu-item>

        <el-menu-item index="/personteacher/renzheng">
          <div id="block"></div>
          <span slot="title" id="title">诚信认证</span>
        </el-menu-item>
        <el-menu-item index="/personteacher/zhuli">
          <div id="block"></div>
          <span slot="title" id="title">需求提醒小助手</span>
        </el-menu-item>
        <div style="display: flex;flex-direction: column;">
          <template>
            <el-popconfirm @confirm="jiedan()" :title="isOnBusinessTxt">
              <button class="jiedan" slot="reference">{{
                isOnBusinesslist[isOnBusiness] }}</button>
            </el-popconfirm>
          </template>
          <template>
            <button class="jiedan" slot="reference" @click="tuichu()">退出登录</button>
          </template>

        </div>

      </el-menu>
      <div class="router"> <router-view></router-view></div>

    </div>


  </div>
</template>

<script>
import navTeacher from '../layout/nav-teacher.vue';
export default {
  components: {
    navTeacher
  },
  data() {
    return {
      isOnBusinesslist: ['开启接单', '关闭接单'],
      isOnBusiness: 0,
      isOnBusinessTxt: '确定开启接单吗',
      Authorization: ''
    }
  },
  created() {
    this.Authorization = localStorage.getItem('Authorization');
    this.$http.get('/Api/Teacher', {
      headers: {
        'Authorization': this.Authorization
      }
    }).then(res => {
      this.isOnBusiness = res.data.data.isOnBusiness
    })
  },
  computed: {
    defaultpath() {
      return this.$route.fullPath
    }
  },
  methods: {
    jiedan() {
      if (this.isOnBusiness == 0) {
        this.$http.post('/Api/Teacher/On', {}, {
          headers: {
            'Authorization': this.Authorization
          }
        }).then(res => {
          console.log(res)
          this.isOnBusiness = 1
          this.isOnBusinessTxt = '确定关闭接单吗'
        })
      }
      if (this.isOnBusiness == 1) {
        this.$http.post('/Api/Teacher/Off', {}, {
          headers: {
            'Authorization': this.Authorization
          }
        }).then(res => {
          console.log(res)
          this.isOnBusiness = 0
          this.isOnBusinessTxt = '确定开启接单吗'
        })
      }
    },
    tuichu() {
      this.$confirm('是否退出当前登录账号?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '已成功退出当前登录账号!'
        });
        setTimeout(() => {
          this.$router.push('/indexno')
        }, 1000)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    }

  }
}
</script>

<style scoped>
.father {
  margin-top: 40px;
  /* width: 1920px; */
  padding-left: 380px;
  display: flex;
  padding-top: 1px;
}

.router {
  width: 657px;
  height: auto;
  margin-left: 80px;
  margin-top: 16px;
}

.jiedan {
  /* Path */
  width: 90px;
  height: 28px;
  background: rgb(1, 162, 153);
  border-radius:
    4px;
  border: 0;
  color: rgb(255, 254, 254);
  font-family: 苹方;
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0px;
  text-align: center;
  margin-left: 30px;
  margin-top: 15px;
}

.el-menu /deep/ #block {
  /* 矩形 3 */
  display: inline-block;
  width: 10px;
  height: 21px;
  background: rgb(1, 162, 153);
}

.el-menu /deep/ #title {
  /* 账户中心 */
  width: 100px;
  height: 26px;
  /* 账户中心 */
  font-family: Microsoft YaHei;
  font-size: 20px;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: 0px;
  text-align: left;
}

.el-menu /deep/ #smalltitle {
  /* 我的简历 */
  height: 44px;
  color: rgb(0, 0, 0);
  font-family: Microsoft YaHei;
  font-size: 18px;
  font-weight: 400;
  line-height: 44px;
  letter-spacing: 0px;
  text-align: left;
}

.el-menu {
  width: 260px;
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/personteacher.vue